module.exports = __webpack_public_path__ + "img/repair.d6d3c47f.svg";